"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types = tslib_1.__importStar(require("./action-types"));
var api = tslib_1.__importStar(require("./api"));
exports.setProgramViews = function (programs) { return ({
    type: types.PROGRAMS_SET_PROGRAM_VIEWS,
    programs: programs
}); };
exports.setProgramViewsLastFetched = function () { return ({
    type: types.PROGRAM_VIEWS_SET_LAST_FETCHED
}); };
exports.getProgramViews = function () { return function (dispatch) {
    return api.getProgramViews()
        .then(function (response) {
        dispatch(exports.setProgramViewsLastFetched());
        dispatch(exports.setProgramViews(response.contests));
    });
}; };
exports.getProgramView = function (programViewId) { return function (dispatch) {
    return api.getProgramView(programViewId)
        .then(function (response) { return dispatch(exports.setProgramViews([response.contest])); });
}; };
//# sourceMappingURL=actions.js.map